import React, { useState } from "react";
import PhoneInput from "./../PhoneInput/PhoneInput";
import Popup from "./PopupWithMessage";

const SendButton = ({ disabled }) => (
  <button type="submit" disabled={disabled} className="button popup-footer__button">Отправить</button>
);

const AppointmentNewPopup = ({ name, authenticity_token }) => {
  const [messageShown, setMessageShown] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [agreedPersonalData, setAgreedPersonalData] = useState(false);
  const [formDisabled, setFormDisabled] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const hideMessage = () => setMessageShown(false);
  const toggleAgreement = () => setAgreed(!agreed);
  const toggleAgreementPersonalData= () => setAgreedPersonalData(!agreedPersonalData);

  const resetState = () => {
    hideMessage()
    setErrorMessage('')
  }

  const handleSubmit = e => {
    e.preventDefault();

    const axios = require('axios');
    const url = '/orders'
    const data = new FormData(e.target);

    setFormDisabled(true);
    setAgreed(false);
    setAgreedPersonalData(false);

    axios
      .post(url, data, {headers: {'Accept': 'application/json'}})
      .then((resp) => {
        if (resp.data.status == 'success') {
          setMessageShown(true);
          window.calltouchRequest(resp.data.data).finally(function() {
            console.log('calltoch sended');
          })
        } else {
          console.log('error', resp.data)
          setErrorMessage(resp.data.data)
        }
      })
      .catch((resp) => {
        console.log('error', resp.data.data)
      })
      .finally(()=> {
        setFormDisabled(false);
        setAgreed(false);
      })
  };

  return (
    <form onSubmit={handleSubmit} className="new_order" id="new_order" acceptCharset="UTF-8" method="post">
      <input name="utf8" type="hidden" value="✓" />
      <input type='hidden' name='authenticity_token' value={authenticity_token} />

      <Popup
        name={name}
        onHide={resetState}
        header="Заявка на прием"
        footer={<SendButton disabled={formDisabled || !agreed || !agreedPersonalData} />}
        message="Спасибо за вашу заявку!"
        messageShown={messageShown}
        hideMessage={hideMessage}
      >
        <div className="popup-description popup-description_indent-b_large">
          С Вами свяжется оператор.
        </div>
        <div className="popup-description popup-description_indent-b_alert">{errorMessage}</div>

        <div className="popup-form">
          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" htmlFor="order_fio">Ваше имя</label>
            <input id="order_fio" className="input-group__input" required name="order[fio]" />
          </div>

          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" htmlFor="order_email">Электронная почта</label>
            <input id="order_email" className="input-group__input" name="order[email]" type="email" />
          </div>

          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" htmlFor="order_phone">Телефон</label>
            <PhoneInput name='order[phone]' id="order_phone" required={true} />
          </div>

          {/* <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" htmlFor="order_comment">Комментарий</label>
            <textarea id="order_comment" className="input-group__textarea" name="order[comment]" />
          </div> */}
          <div className="input-group">
            <label className="input-group__label input-group__label_checkbox">
              <input type="checkbox" onChange={toggleAgreement} checked={agreed} className="input-group__checkbox" required />
              <div className="input-group__checkbox-state" />
              Выражаю согласие на обработку персональных данных в соответствии
              с условиями.
            </label>
          </div>
           <div className="input-group">
            <label className="input-group__label input-group__label_checkbox">
              <input type="checkbox" onChange={toggleAgreementPersonalData} checked={agreedPersonalData} className="input-group__checkbox" required />
              <div className="input-group__checkbox-state" />
              <span>
                Нажимая кнопку, вы даете <a href="https://irk.klinikaexpert.ru/personal-data-consent" target="_blank">согласие на обработку персональных данных</a>
              </span>
            </label>
          </div>
        </div>
      </Popup>
    </form>
  );
};

export default AppointmentNewPopup;
